import { TDashboardComponent } from "MyDashboards/components/ComponentRegistry/types";
import { Element } from "MyDashboards/state/editorTypes";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import React from "react";
import RenderText from "../RichText/RenderText";
import AttributeEditor from "./AttributeEditor";

const Attribute: TDashboardComponent = {
  editorMode: "metadata",
  Edit: ({
    el,
    onChange,
  }: {
    el: Element;
    onChange: (el: Partial<Element>) => void;
  }) => {
    return <AttributeEditor el={el} onChange={onChange} />;
  },
  Render: ({
    el,
    onReady,
  }: {
    el: Element;
    onReady?: (el: Element) => void;
  }) => {
    const ctx = useAppContext();
    const [slideNumber, tagname] = el.tag.split("#");
    if (!el.component) {
      return null;
    }
    return <RenderText el={el} slideNumber={Number(slideNumber)} />;
  },
};
export default Attribute;
